/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { Search_Hit as SearchHit } from '__generated__/graphql-types-do-not-use';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/ent-website';

type InputProps = {
  limitNumberOfResults: number;
  currentSearchQuery: string;
};

type Props = {
  searching: boolean;
  hits: SearchHit[];
} & InputProps;

export function NumberOfResultsSection({ currentSearchQuery, searching, hits = [], limitNumberOfResults }: Props) {
  const styles = {
    message: css`
      font-weight: bold;
      margin-bottom: var(--cds-spacing-100);
    `,
  };
  if (!hits) {
    return null;
  } else if (searching) {
    return (
      <Typography2 component="p" css={styles.message}>
        {_t('Loading search results...')}
      </Typography2>
    );
  }

  const query = currentSearchQuery;
  const numberOfHits = hits?.length;

  return (
    <Typography2 component="p" data-e2e="NumberOfResultsSection" css={styles.message}>
      {numberOfHits ? (
        <FormattedMessage
          message={_t(`Showing our top {limitNumberOfResults} for "{query}"`)}
          limitNumberOfResults={Math.min(limitNumberOfResults, numberOfHits)}
          numberOfHits={numberOfHits}
          query={query}
        />
      ) : (
        <FormattedMessage
          message={query ? _t('No results found for "{query}"') : _t('No results found for your search')}
          query={query}
        />
      )}
    </Typography2>
  );
}

export default React.memo(NumberOfResultsSection);
